import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Observable } from 'rxjs'
import { ArticlesPreviousOrNext, ModuleWebSitePreviousOrNextContent } from '../../interfaces'

@Component({
  selector: 'dmmp-website-previous-or-next-content',
  templateUrl: './website-previous-or-next-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WebsitePreviousOrNextContentComponent {
  @Input() module: ModuleWebSitePreviousOrNextContent
  @Input() identifier: string
  @Input() articlesPaginator$: Observable<ArticlesPreviousOrNext>
  @Output() path: EventEmitter<string> = new EventEmitter<string>()
  constructor() { }


}
